export default __webpack_public_path__ + "assets/images/0ce91b488484ff0a60726b23ddef39a6.svg";